import styled from '@emotion/styled';
import { space } from 'folio-common-components';

export const PageHeading = styled.h2`
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  ${space([32], 'margin-bottom')};
`;
